import GradientBanner from '../../components/Banner/components/GradientBanner';
import {Row, Col, Divider, Badge} from 'antd';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectUserFields} from "../../store/slices/user.slice";
import {selectPortfoliosWithSignals} from "../../store/slices/portfolios.slice";
import RichCard from "../../components/Cards/components/RichCard";
import LocalizedDatetime from "../../components/LocalizedDatetime";
import React from "react";

import useCompany from "../Company/useCompany";
import useAccountInfo from "../../hooks/useAccountInfo";


const MinimalActionCard = ({ text, onClick, imgUrl }) => {
  return (
    <div
      className={`relative w-full px-6 bg-white shadow-sm cursor-pointer`}
      onClick={onClick}
      style={{
        fontFamily: "Poppins, sans-serif",
          fontSize: '1rem'
      }}
    >
      {imgUrl ? (
        // When we have an image:
        <div className="flex items-center justify-between w-full">
          <span
            className="
              w-3/4
              text-left
              overflow-hidden
              text-ellipsis
              whitespace-nowrap
              pr-3
              py-4
            "
          >
            {text}
          </span>
          <img
            src={imgUrl}
            alt="icon"
            className="h-10 w-auto object-contain"
          />
        </div>
      ) : (
        // When we do NOT have an image:
        <div className="flex items-center justify-center w-full py-4">
          <span>{text}</span>
        </div>
      )}
    </div>
  );
};


const DashboardMinimal = () => {
    const {settings, company, username} = useAccountInfo();
    const totalPortfolios = useSelector(state=>state.portfolios?.items?.length??0);
    const portfolios = useSelector(selectPortfoliosWithSignals);
    const navigate = useNavigate();
    const { logoUrl, hasCompany, companyName } = useCompany();



    return (
        <div className={'h-screen'} style={{background: '#FFF'}}>
            <GradientBanner title={`Welcome, ${username}`}
                            description={`You have ${portfolios.length} portfolios with changes`}
                            topChildren={<LocalizedDatetime/>}
                            minHeight={250}
                            maxHeight={350}
                            gradientClassName={'bg-gradient-to-b from-blue-200 to-zinc-200'}

            />
            <Divider/>
            <div className={'xs:w-full xs:px-6 md:px-6 lg:px-6  2xl:w-3/4 xl:w-4/5 mx-auto'}>
                <Row gutter={[64, 16]}>
                    <Col xs={8} lg={6}>
                        <MinimalActionCard text={`Portfolios (${totalPortfolios})`} onClick={()=>navigate('/portfolios')}/>
                    </Col>
                    <Col xs={8} lg={6}>
                        <MinimalActionCard text={'Personalize Model'} onClick={()=>navigate('/builders/portfolio')}/>
                    </Col>
                    <Col xs={8} lg={6}>
                        <MinimalActionCard text={'News & Events'} onClick={()=>navigate('/research/home')}/>
                    </Col>
                    <Col xs={8} lg={6}>
                        {hasCompany ? (
                            <MinimalActionCard text={companyName} imgUrl={logoUrl} onClick={()=>navigate('/company')}/>
                        ):(<MinimalActionCard text={'Learn IA'} onClick={()=>navigate('/resources')}/>)}
                    </Col>
                </Row>
                <Divider/>
                <Row gutter={[48, 32]} justify="center" className="flex items-stretch pt-8"> {/* Key Change: Added flex items-stretch */}
                <Col span={8}>
                    <RichCard
                        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/CardIcons/network.png'}
                        title={'Access Point'}
                        text={'Access all your portfolios, apps, and recent work in one place.'}
                        className={'cursor-pointer hover:shadow-lg h-full'}
                        onClick={()=>navigate('/apps')}
                    />
                </Col>
                <Col span={8}>
                    <Badge.Ribbon text={`${portfolios.length} Trades`} color={'red'}>
                        <RichCard
                            imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/CardIcons/paperplane-silver.png'}
                            onClick={()=>navigate('/signals')}
                            size={84}
                            title={"Trade Desk"}
                            text={portfolios.length > 0 ? <span>
                                View your portfolios with new changes since last rebalanced.
                            </span> : 'You have no portfolios with new changes. Keep up the good work!'}
                            className={'cursor-pointer hover:shadow-lg h-full'}
                        />
                    </Badge.Ribbon>
                </Col>
                <Col span={8}>
                    <RichCard
                        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/CardIcons/apps-plus.png'}
                        title={'Third Party Integrations'}
                        text={'Connect to your trading sytem, CRM, or both to start automating workflows'}
                        className={'cursor-pointer hover:shadow-lg h-full'}
                        onClick={()=>window.open('https://main.yhlsoft.com/auth/users/sign_in?scope=auth&remember_me=0&message=manuallogout&redirect_uri=https%3A%2F%2Fmain.yhlsoft.com%2Fcrm%2Fworkflow%2Fworkflows%2Fworkflow_app_ex%3Fversion%3D2%26hash%3DIy93b3JrZmxvd192Mi93b3JrZmxvd19ncmlk%26branch_id%3Db996ce7a-94c3-4522-8c65-655f0e99c915')}
                    />
                </Col>

            </Row>

            </div>
        </div>
    )
}

export default DashboardMinimal;

